/* eslint-disable @typescript-eslint/no-empty-function */
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import AppHeader from '../../../components/AppHeader';
import Button from '../../../components/Button';
import FileInput from '../../../components/FileInput';
import FilterRadioButton from '../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../components/FilterRadioButtonsContainer';
import { ButtonContainer } from '../../../components/Form';
import FormGroup from '../../../components/FormGroup';
import Loader from '../../../components/Loader';
import NoData from '../../../components/NoData';
import PageHeader from '../../../components/PageHeader';
import { SecondaryButton } from '../../../components/SecondaryButton';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import useGetGeneralAppData from '../../../hooks/useGetGeneralAppData';
import { Card } from './styles';
import useImportConsults from './useImportConsults';

export default function ImportConsults() {
  const {
    isLoading,
    companyCode,
    selectedImportFile,
    setSelectedImportFile,
    csvPreAdmFileName,
    handlePreAdmFileUpload,
    submitPreAdmFile,
    csvPreAdmFileRef,
    csvBaseFileRef,
    csvBaseFileName,
    handleBaseFileUpload,
    submitBaseFile,
    csvMrFileName,
    handleMrFileUpload,
    csvMrFileRef,
    submitMrFile,
  } = useImportConsults();
  const downloadExampleFileRef = useRef<HTMLAnchorElement | null>(null);

  const downloadExampleFileLinkMap: { [key: string]: string } = {
    preAdm: '/files/Modelo importar arquivo PreAdm.csv',
    base: '/files/Modelo importar arquivo Base.csv',
    multi: '/files/Modelo importar arquivo Multi Rotas.csv',
  };

  const labelFileImportMap: { [key: string]: string } = {
    preAdm: 'Pré-Admissional (avulso)',
    base: 'Implantação de Base',
    multi: 'Multi Rotas',
  };

  const fileNameMap: { [key: string]: string } = {
    preAdm: csvPreAdmFileName,
    base: csvBaseFileName,
    multi: csvMrFileName,
  };

  const fileUploadFunctionMap: { [key: string]: (e: React.ChangeEvent<HTMLInputElement>) => void } = {
    preAdm: handlePreAdmFileUpload,
    base: handleBaseFileUpload,
    multi: handleMrFileUpload,
  };

  const fileInputRefMap: { [key: string]:  React.RefObject<HTMLInputElement> } = {
    preAdm: csvPreAdmFileRef,
    base: csvBaseFileRef,
    multi: csvMrFileRef,
  };

  const submitDisabledMap: { [key: string]: boolean } = {
    preAdm: !csvPreAdmFileName,
    base: !csvBaseFileName,
    multi: !csvMrFileName,
  };

  const submitFileFunctionsMap: { [key: string]: () => Promise<void> } = {
    preAdm: submitPreAdmFile,
    base: submitBaseFile,
    multi: submitMrFile,
  };

  const { isCustomer } = useGetGeneralAppData();
  // const { isDifferentSubdomain } = useAppContext();

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="ImportConsultsFile" />

      <Transitions>
        <Loader isLoading={isLoading} />
        <PageHeader title="Importação de Arquivo Para Roteirização" />

        {!companyCode && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
                Selecione uma empresa para realizar uma importação de arquivo.
              </>
            )}
          />
        )}

        {!!companyCode && (
          <>
            <Card>
              <FormGroup>
                <label htmlFor="contactName">1. Selecione o tipo de Importação de Arquivo</label>
                <FilterRadioButtonsContainer>
                  <FilterRadioButton selected={selectedImportFile === 'preAdm'} onClick={() => setSelectedImportFile('preAdm')}>
                  Pré-Admissional (avulso)
                  </FilterRadioButton>
                  <FilterRadioButton selected={selectedImportFile === 'multi'} onClick={() => setSelectedImportFile('multi')}>
                    Multirotas
                  </FilterRadioButton>
                  {!isCustomer && (
                    <FilterRadioButton selected={selectedImportFile === 'base'} onClick={() => setSelectedImportFile('base')}>
                    Implantação de Base
                    </FilterRadioButton>
                  )}
                </FilterRadioButtonsContainer>
              </FormGroup>

              <FormGroup>
                <Link
                  to={downloadExampleFileLinkMap[selectedImportFile]}
                  target="_blank"
                  download
                  style={{ display: 'none' }}
                  ref={downloadExampleFileRef}
                />
                <label htmlFor="contactName">2. Se Necessário, baixe o modelo de arquivo aqui. Não se esqueça de apagar a linha 2, que contém as explicações e instruções de cada campo, antes de salvar o arquivo para importação.</label>
                <SecondaryButton onClick={() => { downloadExampleFileRef.current!.click();}}>
                  Modelo Arquivo {labelFileImportMap[selectedImportFile]}
                </SecondaryButton>
              </FormGroup>

              <FormGroup>
                <label htmlFor="contactName">3. Escolha o Arquivo a ser Importado</label>
                <FileInput
                  fileNameChoosed={fileNameMap[selectedImportFile]}
                  onFileUpload={fileUploadFunctionMap[selectedImportFile]}
                  acceptedFiles=".csv"
                  hasSubmitAction={false}
                  hiddenFileInput={fileInputRefMap[selectedImportFile]}
                />
              </FormGroup>
            </Card>

            <ButtonContainer>
              <Button disabled={submitDisabledMap[selectedImportFile]} onClick={submitFileFunctionsMap[selectedImportFile]}>
                Importar Arquivo {labelFileImportMap[selectedImportFile]}
              </Button>
            </ButtonContainer>
          </>
        )}
      </Transitions>
    </>
  );
}
